import getVideoId from 'get-video-id'

import player from '@/js/util/props/player'

import PlayerVimeo from './PlayerVimeo'
import PlayerYoutube from './PlayerYoutube'

export default {
  components: {
    PlayerVimeo,
    PlayerYoutube,
  },
  props: { ...player },

  data() {
    const { service } = getVideoId(this.url)
    return { service }
  },

  computed: {
    PlayerLoaded() {
      return `Player${this.playerService}`
    },
    playerService() {
      const { service } = this
      return service.charAt(0).toUpperCase().concat(`${service.slice(1)}`)
    },
  },

  render(createElement) {
    const props = {
      url: this.url,
      options: this.options,
      useModal: this.useModal,
      playerId: this.playerId,
    }
    return createElement(this.PlayerLoaded, { props })
  },
}



// WEBPACK FOOTER //
// ./src/js/components/player/PlayerLoader.js